import { redirectTo } from "../../utils/httpHelper";
import {
  verifyTransaction,
  generateDpoPayPortal,
  purchasePPVOrder,
  purchaseSubscription,
  verifyCouponCode,
} from "../../services/paymentService";
import { formatUrl } from "../../utils/domHelper";
import { getGatewayActive } from "../../services/paymentService";
import { isAuth } from "../../utils/authHelper";
import {
  createStripePurchaseCard,
  stripeAddCardFields,
} from "../../components/PPV/StripePurchaseCard";
import {
  createAuthorizeNetPurchaseCard,
  authorizeNetAddCardFields,
} from "../../components/PPV/AuthorizeNetPurchaseCard";
import { createDPOPayPurchaseCard } from "../../components/PPV/DPOPayPurchaseCard";
import { createCardForm } from "../../utils/authorizeNetCardForm";
import { AppConfig } from "../../constants/config";

let selectedPlan = null;

// PPV
export const registerPayment = async (
  baseUrl,
  apiKey,
  data,
  container,
  is_subscription = false
) => {
  const activeGW = await getGatewayActive(baseUrl, apiKey);
  if (activeGW) {
    if (activeGW.gateway_provider == 2) {
      let stripeApiKey = activeGW.credential_information.publishable_api_key;
      stripePayment(
        baseUrl,
        apiKey,
        stripeApiKey,
        data,
        container,
        is_subscription
      );
    } else if (activeGW.gateway_provider == 3) {
      let authorizeNetLoginId = activeGW.credential_information.api_login_id;
      let authorizeNetPublicClientKey = activeGW.credential_information.public_client_key;
      authorizeNetPayment(
        baseUrl,
        apiKey,
        authorizeNetLoginId,
        authorizeNetPublicClientKey,
        data,
        container,
        is_subscription
      );
    } else if (activeGW.gateway_provider == 4) {
      const companyToken = activeGW.credential_information.company_token;
      const serviceToken = activeGW.credential_information.service;
      dpoPayPayment(
        baseUrl,
        apiKey,
        companyToken,
        serviceToken,
        data,
        container,
        is_subscription);
    }
  }
};

// Stripe Payment
async function stripePayment(
  baseUrl,
  apiKey,
  stripeApiKey,
  data,
  container,
  is_subscription
) {
  let isLogged = isAuth();
  let loginToken = JSON.parse(localStorage.getItem("loginToken") || "{}");
  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());

  const script_script = document.createElement("script");
  script_script.src = "https://js.stripe.com/v3/";
  script_script.async = true;

  // Load stripe script
  script_script.addEventListener("load", () => {
    $(createStripePurchaseCard(data, is_subscription)).appendTo(container);

    var planSelect = document.getElementById('plan_value');
    var submitButtonText = "Submit Payment"
    var addCardFields = false;

    if (planSelect) {
      planSelect.addEventListener('change', function() {
        var selectedOption = this.options[this.selectedIndex];
        var selectedPrice = selectedOption.getAttribute('data-price');
        var creditCardField = document.getElementById('stripe-credit-card-field');
        var couponField = document.getElementById('coupon-field');
        var submitButton = document.getElementById('stripe-submit-payment');

        if (creditCardField) {
          creditCardField.style.display = parseFloat(selectedPrice) == 0 ? 'none' : 'flex';
          submitButton.innerHTML = parseFloat(selectedPrice) == 0 ? "Subscribe" : "Submit Payment";
        }

        if (couponField) {
          couponField.style.display = parseFloat(selectedPrice) == 0 ? 'none' : 'block';
          submitButton.innerHTML = parseFloat(selectedPrice) == 0 ? "Subscribe" : "Submit Payment";
        }
      });
    } else {
      console.error("Element with ID 'plan_value' not found");
    }

    if ($.type(data) === "array") {
      // initStripe(true, "Submit Payment", data[0]);
      const selectPlanDropdown = $('select[name="plan_id"]');

      if (data.length > 1) {
        selectedPlan = data[0];
        selectPlanDropdown.val(selectedPlan.uuid);
        selectPlanDropdown.change(function () {
          selectedPlan = data.find((item) => item.uuid === this.value);
          submitButtonText = "Submit Payment";
          if (selectedPlan.is_free) {
            submitButtonText = "Subscribe";
          } else {
            submitButtonText = "Submit Payment";
            addCardFields = true;
          }
        });
      } else if (data.length === 1) {
        // If there's only one plan, select it by default and trigger the change event
        selectedPlan = data[0];
        selectPlanDropdown.val(selectedPlan.uuid).change();
        submitButtonText = "Submit Payment";
        if (selectedPlan.is_free) {
          submitButtonText = "Subscribe";
        } else {
          submitButtonText = "Submit Payment";
          addCardFields = true;
        }
      }
    } else {
      // Single plan
      selectedPlan = data;
      submitButtonText = "Submit Payment";
      if (selectedPlan.is_free) {
        submitButtonText = "Subscribe";
      } else {
        submitButtonText = "Submit Payment";
        addCardFields = true;
      }
    }

    if (addCardFields) {
      stripeAddCardFields();
    }

    initStripe(is_subscription, submitButtonText, selectedPlan);
  });

  document.head.appendChild(script_script);

  // init Stripe
  async function initStripe(is_subscription, submitButtonText="Submit Payment", selectedPlan) {
    const stripe = Stripe(stripeApiKey);
    const elements = stripe.elements();
    let cardElement = elements.create("card", {
      hidePostalCode: true,
    });

    // On Submit Payment Form
    let errorDiv = $("#stripe-card-errors");
    let stripeForm = $("#stripe-payment-form");
    let submitButton = $("#stripe-submit-payment");
    let stripeCardField = document.getElementById('stripe-credit-card-field');

    stripeCardField.style.display = 'none';
    submitButton.html("Subscribe");

    if (isLogged) {
      let user_email = loginToken.user
        ? loginToken.user.email
        : loginToken.profile.email;
      $("#email").val(user_email).attr("disabled", true);
    }

    if (!selectedPlan.is_free) {
      stripeCardField.style.display = 'flex';
      submitButton.html("Submit Payment");
      stripeAddCardFields();
      cardElement.mount("#stripe-card-element");
    }
    submitButton.on("click", function (event) {
      event.preventDefault();

      submitButton.attr("disabled", true);
      submitButton.html("Processing...");

      errorDiv.html("");
      let email = stripeForm.find("#email").val();
      let first_name = stripeForm.find("#first_name").val();
      let last_name = stripeForm.find("#last_name").val();
      let password = stripeForm.find("#password").val();
      let coupon_code = stripeForm.find("#coupon_code").val();

      // Trim all fields
      const trimmedFirstName = first_name.trim();
      const trimmedLastName = last_name.trim();
      const trimmedPassword = password.trim();
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      let isValid = true;
      let validationMessage = "Required Fields are missing!";

      // Validate other fields
      if (trimmedFirstName === "") {
        isValid = false;
        validationMessage = "Enter your first name!";
      }

      if (trimmedLastName === "") {
        isValid = false;
        validationMessage = "Enter your last name!";
      }

      if (!emailRegex.test(email)) {
        isValid = false;
        validationMessage = "Enter a valid email address!";
      }

      if (trimmedPassword === "") {
        isValid = false;
        validationMessage = "Enter your password!";
      }
      
      if (!isValid) {
        submitButton.attr("disabled", false);
        submitButton.html(submitButtonText);
        errorDiv.html(validationMessage);
        return false;
      }

      let payload = {
        email: email,
        first_name: first_name,
        last_name: last_name,
        password: password,
        uuid: selectedPlan.uuid,
      };
      if (
        coupon_code !== undefined &&
        coupon_code !== "" &&
        coupon_code !== null
      ) {
        payload["coupon_code"] = coupon_code;
      }

      if (
        params.hasOwnProperty("deviceType") &&
        params.hasOwnProperty("deviceId")
      ) {
        payload["deviceType"] = params.deviceType;
        payload["deviceId"] = params.deviceId;
      }

      if (is_subscription && selectedPlan.is_free) {
        capturePayment(payload, submitButton);
      } else {
        stripeCard(stripe, cardElement, payload, submitButton);
      }
    });

    // close popup form
    $("#closeStripePurchaseCard").click(function () {
      $("#stripePurchaseCard").remove();
    });

    // Apply coupon code
    $("#coupon_apply_btn").on("click", function () {
      applyCouponCode(stripeForm.find("#coupon_code").val());
    });
  }

  // Stripe Card
  async function stripeCard(stripe, cardElement, payload, submitButton) {
    stripe
      .createPaymentMethod({
        type: "card",
        card: cardElement,
        billing_details: {
          name: `${payload["first_name"]} ${payload["last_name"]}`,
          email: payload["email"],
        },
      })
      .then(async function (result) {
        if ("paymentMethod" in result) {
          payload["payment_method_id"] = result.paymentMethod.id;
          capturePayment(payload, submitButton);
        } else {
          submitButton.attr("disabled", false);
          submitButton.html("Submit Payment");
        }
      });
  }

  // Capture Payment
  async function capturePayment(payload, submitButton) {
    let res;
    if (is_subscription) {
      res = await purchaseSubscription(
        baseUrl,
        apiKey,
        JSON.stringify(payload)
      );
    } else {
      payload["content_type"] = selectedPlan.content_type;
      res = await purchasePPVOrder(baseUrl, apiKey, JSON.stringify(payload));
    }

    if (res !== undefined) {
      if ("credentials" in res && res.credentials) {
        localStorage.setItem("loginToken", JSON.stringify(res.credentials));
        isLogged = true;
        loginToken = res.credentials;
      }
      $("#stripePurchaseCard").remove();

      if (window.location.href.indexOf("/purchase-ppv-event") !== -1) {
        let current_datetime = moment();
        let event_datetime = moment(selectedPlan.event_dates.lower);
        let diff_datetime = current_datetime.diff(event_datetime, "minuts");
        if (diff_datetime >= 0) {
          $(".ppv-event-banner-btn")
            .html("Watch Now")
            .addClass("ppv_event_watch_live_btn");
        } else {
          $(".ppv-event-banner-btn").remove();
          $(".ppv-event-banner-btn-wrapper").html(`
            <p style="color:green">
              This event will start at ${moment(
                selectedPlan.event_dates.lower
              ).format("hh:mm A")} on ${moment(
            selectedPlan.event_dates.lower
          ).format("ll")} you will be able to watch it by going to this page 
              <b><a href="#" class="ppv_event_watch_live_btn">${
                selectedPlan.title
              }</a></b>
            </p>
          `);
        }

        $(".ppv_event_watch_live_btn").on("click", function () {
          const nextURL = `/watch-live`;
          window.location = formatUrl(nextURL);
        });
      } else {
        window.location.reload();
      }
    } else {
      console.log("error");
      console.log(res);
    }

    submitButton.attr("disabled", false);
    submitButton.html("Submit Payment");
  }

  // Apply Coupon Code
  async function applyCouponCode(coupon_code) {
    let payload = JSON.stringify({
      plan_uuid: selectedPlan.uuid,
      offer_code: coupon_code,
    });
    let res = await verifyCouponCode(baseUrl, apiKey, payload);
    if (res != undefined && res.hasOwnProperty("discounted_price")) {
      $(".price-p")
        .css({
          "text-align": "center",
          "font-size": "20px",
          color: "black",
          "text-decoration": "line-through",
        })
        .after(
          `<p class="purchase-card-price" style="text-align:center;">${res.discounted_price}</p>`
        );
      $("#coupon_apply_btn").remove();
      $("#coupon_code").attr("disabled", true);
    }
  }
}

// Authorize Net Payment
async function authorizeNetPayment(
  baseUrl,
  apiKey,
  authorizeNetLoginId,
  authorizeNetPublicClientKey,
  data,
  container,
  is_subscription
) {
  let isLogged = isAuth();
  let loginToken = JSON.parse(localStorage.getItem("loginToken") || "{}");
  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());

  
  let accept_js_src = "https://jstest.authorize.net/v1/Accept.js";

  if ( AppConfig.env === 'prod' && AppConfig.sandboxLoginId != authorizeNetLoginId) {
    accept_js_src = "https://js.authorize.net/v1/Accept.js";
  }

  const authorize_net_script = document.createElement('script');
  authorize_net_script.src = accept_js_src;
  authorize_net_script.async = true;

  // Load Authorize.Net script
  authorize_net_script.addEventListener("load", () => {
    $(createAuthorizeNetPurchaseCard(data, is_subscription, {authorizeNetPublicClientKey, authorizeNetLoginId})).appendTo(container);

    var planSelect = document.getElementById('plan_value');
    var submitButtonText = "Submit Payment"
    var addCardFields = false;

    if (planSelect) {
      planSelect.addEventListener('change', function() {
        var selectedOption = this.options[this.selectedIndex];
        var selectedPrice = selectedOption.getAttribute('data-price');
        var creditCardField = document.getElementById('authorize-net-credit-card-field');
        var couponField = document.getElementById('coupon-field');
        var submitButton = document.getElementById('authorize-net-submit-payment');

        if (creditCardField) {
          creditCardField.style.display = parseFloat(selectedPrice) == 0 ? 'none' : 'flex';
          submitButton.innerHTML = parseFloat(selectedPrice) == 0 ? "Subscribe" : "Submit Payment";
        }

        if (couponField) {
          couponField.style.display = parseFloat(selectedPrice) == 0 ? 'none' : 'block';
          submitButton.innerHTML = parseFloat(selectedPrice) == 0 ? "Subscribe" : "Submit Payment";
        }
      });
    } else {
      console.error("Element with ID 'plan_value' not found");
    }

    if ($.type(data) === "array") {
      const selectPlanDropdown = $('select[name="plan_id"]');

      if (data.length > 1) {
        selectedPlan = data[0];
        selectPlanDropdown.val(selectedPlan.uuid);
        selectPlanDropdown.change(function () {
          selectedPlan = data.find((item) => item.uuid === this.value);
          submitButtonText = "Submit Payment";
          if (selectedPlan.is_free) {
            submitButtonText = "Subscribe";
          } else {
            submitButtonText = "Submit Payment";
            addCardFields = true;
          }
        });
      } else if (data.length === 1) {
        // If there's only one plan, select it by default and trigger the change event
        selectedPlan = data[0];
        selectPlanDropdown.val(selectedPlan.uuid).change();
        submitButtonText = "Submit Payment";
        if (selectedPlan.is_free) {
          submitButtonText = "Subscribe";
        } else {
          submitButtonText = "Submit Payment";
          addCardFields = true;
        }
      }
    } else {
      // Single plan
      selectedPlan = data;
      submitButtonText = "Submit Payment";
      if (selectedPlan.is_free) {
        submitButtonText = "Subscribe";
      } else {
        submitButtonText = "Submit Payment";
        addCardFields = true;
      }
    }

    if (addCardFields) {
      authorizeNetAddCardFields();
      createCardForm();
    }

    initAuthorizeNet(is_subscription, submitButtonText, selectedPlan);
  });

  document.body.appendChild(authorize_net_script);

  // init AuthorizeNet
  async function initAuthorizeNet(is_subscription, submitButtonText="Submit Payment", selectedPlan) {
    if (isLogged) {
      let user_email = loginToken.user
        ? loginToken.user.email
        : loginToken.profile.email;
      $("#email").val(user_email).attr("disabled", true);
    }
    
    if (!selectedPlan.is_free) {
      authorizeNetAddCardFields();
      createCardForm();
    }

    // On Submit Payment Form
    let errorDiv = $("#authorize-net-card-errors");
    let authorizeNetForm = $("#authorize-net-payment-form");
    let submitButton = $("#authorize-net-submit-payment");
    let authorizeNetCardJs = $("#authorize-net-card-element");

    submitButton.on("click", function (event) {
      event.preventDefault();
      
      var formData = new FormData(event.currentTarget.form);
      formData = Object.fromEntries(formData);
      selectedPlan = data.find((item) => item.uuid === formData.plan_id);

      submitButton.attr("disabled", true);
      submitButton.html("Processing...");

      errorDiv.html("");
      let email = authorizeNetForm.find("#email").val();
      let first_name = authorizeNetForm.find("#first_name").val();
      let last_name = authorizeNetForm.find("#last_name").val();
      let password = authorizeNetForm.find("#password").val();
      let card_number = authorizeNetCardJs.find("#cardNumber").val();
      let card_name = authorizeNetCardJs.find("#cardName").val();
      let expiry_date = authorizeNetCardJs.find(".expiry").val();
      let card_code = authorizeNetCardJs.find("#cardCode").val();

      const validateExpiry = (expiry) => {
        // Check if the format is MM/YY or MM/YYYY
        const expiryRegex = /^(0[1-9]|1[0-2])\/?([0-9]{2}|[0-9]{4})$/;
        expiry = expiry.replace(/\s+/g, '');
        
        if (!expiryRegex.test(expiry)) {
          return false;
        }
      
        // Split month and year
        let [month, year] = expiry.split("/");
      
        // Convert 2-digit year to 4-digit year (e.g., '23' becomes '2023')
        if (year.length === 2) {
          year = "20" + year;
        }
      
        // Convert to integers
        const currentDate = new Date();
        const expiryDate = new Date(`${year}-${month}-01`);
        
        // Set expiry to the last day of the month
        expiryDate.setMonth(expiryDate.getMonth() + 1);
        expiryDate.setDate(0);
      
        // Check if expiry date is in the future
        return expiryDate > currentDate;
      };

      // Trim all fields
      const trimmedFirstName = first_name.trim();
      const trimmedLastName = last_name.trim();
      const trimmedPassword = password.trim();
      const trimmedCardNumber = card_number ? card_number.trim() : "";
      const trimmedCardName = card_name? card_name.trim() : "";
      const trimmedCardCode = card_code ? card_code.trim() : "";
      const trimmedExpiryDate = expiry_date ? expiry_date.trim() : "";
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      let isValid = true;
      let validationMessage = "Required fields are missing";

       // Validate if all fields are empty
      if (!trimmedCardNumber && !trimmedCardName && !trimmedCardCode && selectedPlan.price > 0) {
        isValid = false;
        validationMessage = "Card details are missing";
      } else if (!trimmedFirstName) {
        isValid = false;
        validationMessage = "Enter your first name";
      } else if (!trimmedLastName) {
        isValid = false;
        validationMessage = "Enter your last name";
      } else if (!emailRegex.test(email)) {
        isValid = false;
        validationMessage = "Enter a valid email address";
      } else if (!trimmedPassword) {
        isValid = false;
        validationMessage = "Enter your password";
      } else if (selectedPlan.price > 0) {
        isValid = validateExpiry(trimmedExpiryDate);
        validationMessage = "Card expiry date is invalid";
      }
      
      if (!isValid) {
        submitButton.attr("disabled", false);
        submitButton.html(submitButtonText);
        errorDiv.html(validationMessage);
        return false;
      }

      let payload = {
        email: email,
        first_name: first_name,
        last_name: last_name,
        password: password,
        uuid: selectedPlan.uuid,
      }

      if (
        coupon_code !== undefined &&
        coupon_code !== "" &&
        coupon_code !== null
      ) {
        payload["coupon_code"] = coupon_code;
      }

      if (
        params.hasOwnProperty("deviceType") &&
        params.hasOwnProperty("deviceId")
      ) {
        payload["deviceType"] = params.deviceType;
        payload["deviceId"] = params.deviceId;
      }

      if (is_subscription && selectedPlan.is_free) {
        capturePayment(payload, submitButton);
      } else {
        var authData = {};
          authData.clientKey = authorizeNetPublicClientKey;
          authData.apiLoginID = authorizeNetLoginId;

        var myCard = $('#my-card');
        var cardData = {};
          cardData.cardNumber = myCard.CardJs('cardNumber').replace(/\s+/g, '');
          cardData.fullName = document.getElementById("cardName").value;
          cardData.month = myCard.CardJs('expiryMonth');
          cardData.year = myCard.CardJs('expiryYear');
          cardData.cardCode = myCard.CardJs('cvc');
  
        var secureData = {};
            secureData.authData = authData;
            secureData.cardData = cardData;
        console.log("Accept JS executing");

        // Use Accept.js to tokenize the card data
        Accept.dispatchData(secureData, function(response) {
          if (response && response.opaqueData) {
              // Insert capturePayment function here
              payload["opaque_card_data"] = response.opaqueData;
              capturePayment(payload, submitButton);
          } else {
              console.error("Error:", response);
          }
        });
      }
    });

    // close popup form
    $("#closeAuthorizeNetPurchaseCard").click(function () {
      $("#authorizeNetPurchaseCard .payment-form").remove();
      $('#authorize-net-card-element .payment-form').remove();
      $("#authorizeNetPurchaseCard").remove();
    });

    // Apply coupon code
    $("#coupon_apply_btn").on("click", function () {
      applyCouponCode(authorizeNetForm.find("#coupon_code").val());
    });
  }

  // Capture Payment
  async function capturePayment(payload, submitButton) {
    let res;
    if (is_subscription) {
      res = await purchaseSubscription(
        baseUrl,
        apiKey,
        JSON.stringify(payload)
      );
    } else {
      payload["content_type"] = selectedPlan.content_type;
      res = await purchasePPVOrder(baseUrl, apiKey, JSON.stringify(payload));
    }

    if (res !== undefined) {
      if ("credentials" in res && res.credentials) {
        localStorage.setItem("loginToken", JSON.stringify(res.credentials));
        isLogged = true;
        loginToken = res.credentials;
      }
      $("#authorizeNetPurchaseCard").remove();

      if (window.location.href.indexOf("/purchase-ppv-event") !== -1) {
        let current_datetime = moment();
        let event_datetime = moment(selectedPlan.event_dates.lower);
        let diff_datetime = current_datetime.diff(event_datetime, "minuts");
        if (diff_datetime >= 0) {
          $(".ppv-event-banner-btn")
            .html("Watch Now")
            .addClass("ppv_event_watch_live_btn");
        } else {
          $(".ppv-event-banner-btn").remove();
          $(".ppv-event-banner-btn-wrapper").html(`
            <p style="color:green">
              This event will start at ${moment(
                selectedPlan.event_dates.lower
              ).format("hh:mm A")} on ${moment(
            selectedPlan.event_dates.lower
          ).format("ll")} you will be able to watch it by going to this page 
              <b><a href="#" class="ppv_event_watch_live_btn">${
                selectedPlan.title
              }</a></b>
            </p>
          `);
        }

        $(".ppv_event_watch_live_btn").on("click", function () {
          const nextURL = `/watch-live`;
          window.location = formatUrl(nextURL);
        });
      } else {
        window.location.reload();
      }
    } else {
      console.log("error");
      console.log(res);
    }

    submitButton.attr("disabled", false);
    submitButton.html("Submit Payment");
  }

  // Apply Coupon Code
  async function applyCouponCode(coupon_code) {
    let payload = JSON.stringify({
      plan_uuid: selectedPlan.uuid,
      offer_code: coupon_code,
    });
    let res = await verifyCouponCode(baseUrl, apiKey, payload);
    if (res != undefined && res.hasOwnProperty("discounted_price")) {
      $(".price-p")
        .css({
          "text-align": "center",
          "font-size": "20px",
          color: "black",
          "text-decoration": "line-through",
        })
        .after(
          `<p class="purchase-card-price" style="text-align:center;">${res.discounted_price}</p>`
        );
      $("#coupon_apply_btn").remove();
      $("#coupon_code").attr("disabled", true);
    }
  }
}

async function dpoPayPayment(baseUrl, apiKey, companyToken, serviceToken, data, container, is_subscription) {
  const isLogged = isAuth();
  let loginToken = JSON.parse(localStorage.getItem("loginToken") || "{}");
  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());

  // Render the payment form
  $(container).html(createDPOPayPurchaseCard(data, is_subscription));
  const form = $(container).find(".purchase-card");
  const submitButton = $(container).find("#dpo-pay-submit-payment");
  if (is_subscription) {
    submitButton.html("Proceed to Payment");
  } else {
    submitButton.html("Subscribe");
  }

  // Event listener for the dropdown
  const planSelect = form.find("select[name='plan_id']");
  planSelect.on("change", function () {
    const selectedPlanId = $(this).val();
    const selectedPlan = data.find((plan) => plan.uuid === selectedPlanId);

    if (selectedPlan && selectedPlan.is_free) {
      // Change submit button text for free plans
      submitButton.html("Subscribe");
    } else {
      // Default text for paid plans
      if (is_subscription) {
        submitButton.html("Proceed to Payment");
      } else {
        submitButton.html("Subscribe");
      }
    }
  });

  /**
    * Handles form submission for payment.
    */
    submitButton.on("click", async (event) => {
      event.preventDefault();
      const errorDiv = $("#dpo-pay-card-errors");

      const plan_id = is_subscription ? form.find("select[name='plan_id']").val() : null;
      const firstName = form.find("input[name='first_name']").val().trim();
      const lastName = form.find("input[name='last_name']").val().trim();
      const email = form.find("input[name='email']").val().trim();
      const password = form.find("input[name='password']").val().trim();

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const validationMessage =
        !firstName ? "Enter your first name!" :
        !lastName ? "Enter your last name!" :
        !emailRegex.test(email) ? "Enter a valid email address!" :
        !password ? "Enter your password!" :
        (is_subscription && !plan_id) ? "Select a plan!" :
        null;

      if (validationMessage) {
        errorDiv.text(validationMessage);
        return;
      }

      const now = new Date();
      const formattedDate = `${now.getFullYear()}/${String(now.getMonth() + 1).padStart(2, "0")}/${String(now.getDate()).padStart(2, "0")} ${String(now.getHours()).padStart(2, "0")}:${String(now.getMinutes()).padStart(2, "0")}:${String(now.getSeconds()).padStart(2, "0")}`;

      const selectedPlan = is_subscription
        ? data.find((plan) => plan.uuid === plan_id)
        : data;

      if (!selectedPlan) {
        errorDiv.text("Selected plan not found.");
        return;
      }

      if (selectedPlan.is_free) {
        const payload = {
          email,
          first_name: firstName,
          last_name: lastName,
          password,
          uuid: plan_id,
        };
        const response = await purchaseSubscription(baseUrl, apiKey, JSON.stringify(payload));
        if (response?.credentials) {
          localStorage.setItem("loginToken", JSON.stringify(response.credentials));
          window.location.reload();
        } else {
          errorDiv.text("An error occurred while processing your request.");
        }
      }

      const xmlPayload = `<?xml version="1.0" encoding="utf-8"?>
        <API3G>
          <CompanyToken>${companyToken}</CompanyToken>
          <Request>createToken</Request>
          <Transaction>
            <PaymentAmount>${selectedPlan.price}</PaymentAmount>
            <PaymentCurrency>${selectedPlan.price_currency}</PaymentCurrency>
            <PTL>5</PTL>
            <customerFirstName>${firstName}</customerFirstName>
            <customerLastName>${lastName}</customerLastName>
            <customerEmail>${email}</customerEmail>
            <AllowRecurrent>1</AllowRecurrent>
          </Transaction>
          <Services>
            <Service>
              <ServiceType>${serviceToken}</ServiceType>
              <ServiceDescription>${selectedPlan.title}</ServiceDescription>
              <ServiceDate>${formattedDate}</ServiceDate>
            </Service>
          </Services>
          <Additional>
            <BlockPayment>BT</BlockPayment>
            <BlockPayment>PP</BlockPayment>
          </Additional>
        </API3G>`;

      try {
        const res = await generateDpoPayPortal(baseUrl, apiKey, xmlPayload);
        const transactionToken = res.split("ID=")[1];

        const paymentWindow = window.open(res, "_blank", "width=800,height=600");
        const interval = setInterval(async () => {
          if (paymentWindow.closed) {
            clearInterval(interval);

            const verifyResponse = await verifyTransaction(baseUrl, apiKey, companyToken, transactionToken);
            if (verifyResponse.success) {
              const payload = {
                TransToken: transactionToken,
                VerificationDetails: verifyResponse,
                email,
                first_name: firstName,
                last_name: lastName,
                password,
              };

              if (is_subscription) {
                payload["uuid"] = plan_id;
              } else {
                payload["uuid"] = data.uuid;
                payload["content_type"] = data.content_type
              }

              const purchaseMethod = is_subscription ? purchaseSubscription : purchasePPVOrder;
              const response = await purchaseMethod(baseUrl, apiKey, JSON.stringify(payload));

              if (response?.credentials) {
                localStorage.setItem("loginToken", JSON.stringify(response.credentials));
                window.location.reload();
              } else {
                errorDiv.text("An error occurred while processing your request.");
              }
            } else {
              errorDiv.text("Transaction verification failed.");
            }
          }
        }, 1000);
      } catch (error) {
        errorDiv.text("An error occurred while processing the payment.");
      }
    });

  $("#closeDPOPayPurchaseCard").on("click", closePaymentForm);

  function closePaymentForm() {
    $("#DPOPayPurchaseCard, #dpo-pay-card-element .payment-form").remove();
  }
}

export const registerCancelCheckoutOrder = () => {
  $(".cancel-redirect").click(function () {
    redirectTo();
  });

  $(".do-redirect").click(function () {
    redirectTo();
  });
};
